import {Observable} from 'rxjs';
import {ConfigurationService} from '../Configuration/configuration-service';
import {IPublisherInitializer} from './ipublisher-initializer';

export enum DataType {
    GRID,
    GRIDS,  // list of GRID without content
    ROW,
    INTRADAY,
    HISTORICAL,
    FUND_HISTORICAL,
    DIVIDEND,
    CORRECTION,
    LIST_NEWS,
    NEWS,

    // METADATA
    META_LIST_GRIDS, // List of available GRIDS


    // WIDGET CONFIGURATION
    R_OUTCONF,      // Widget configuration (data.js format)
    R_WIDGET,
    R_WIDGET_PART,
    W_WIDGET,
    W_WIDGET_PART
}

export interface IPublisher {
    /**
     * Read content from remote service
     * @param publisherParameters Map af rewriteble parameter. This Map is returned calling getRewritableParameterMap().
     * @param SubscribeObjInfo specifi parameter for call
     * @param dataType datatype requested
     */
    // tslint:disable-next-line:ban-types
    read(publisherParameters: Map<string, string>, SubscribeObjInfo: string[], dataType: DataType): Observable<Object>;
    initialize(initializer: IPublisherInitializer, configuration: ConfigurationService);

    /**
     * Return a Map containing rewritable parameter.
     * All values are initializate whith initial values as configuration
     * This Map must be used in read method
     */
    getRewritableParameterMap(): Map<string, string>;
}
